export const constState = {
    urlImg: 'assets/img-png/',
    red1: '#f42525',
    backgroundGrey: '#f7f7f7',
    tabBackground: '#FAFAFA',
    primaryColor: '#800000',
    primaryDefault: 'primary',
    menuGrey: 'rgb(250,250,250)',
    toolbarColors: '#800000',
    accentColor: 'rgba(255, 255, 255, 0.2)',
    datePickerMenuWidth: '290px',
    datePicker: '400',
    langSelectIconH: '17',
    langSelectIconW: '20',
    langSelectIconMH: '20',
    langSelectIconMW: '23',
    INVOICE_FILE_TYPE: 1,
    POD_FILE_TYPE: 2,
    SEAL_IMAGE_FILE_TYPE: 3
}

